module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (50).a2d7391b.jpg";